import React, {ReactNode} from 'react';
import {observer} from 'mobx-react-lite';
import {useRootStore} from "@stores/AppStateContext";

import {EmptyListView} from '../ListView/EmptyListView'
import {ItemLine} from "../ItemLine/ItemLine";

import './Recent.css';

export const Recent = observer(() => {
    const rootStore = useRootStore();
    const activeWorkspace = rootStore.view.workspace!;

    const recentElements: ReactNode[] = [];
    for (const itemId of activeWorkspace.recentIds) {
        const item =  activeWorkspace.items.get(itemId);
        if (!item) {
            continue;
        }
        recentElements.push(
            <ItemLine
                key={itemId}
                item={item}
                level={0}
            />
        )
    }

    if (recentElements.length === 0) {
        return (
            <EmptyListView view={'recent'}/>
        )
    }

    return (
        <div className='Recent'>
            {recentElements}
        </div>
    )
}
)
